<div class="row">
  <div class="col-md-12">
    <h5 class="card-title">Mis Pagos</h5>
    <p>Aquí puede ver su saldo a favor y el historial de sus pagos</p>
    <hr class="linea" />
  </div>
</div>

<!-- SALDO A FAVOR -->
<div class="row">
  <div class="col-12 col-md-8">
    <div class="card">
      <div class="card-body">
        <div class="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div>
            <h6 class="text-muted mb-1">
              <i class="fas fa-wallet text-info"></i> Saldo a favor disponible
            </h6>
            @if (saldo > 0) {
            <p class="text-muted mb-0 font-size-13">
              Se aplicará automáticamente en tu próxima cita.
            </p>
            } @else {
            <p class="text-muted mb-0 font-size-13">
              Tu saldo a favor se genera cuando cancelas una cita que ya habías pagado.
            </p>
            }
          </div>
          <h3 class="mb-0" [class.text-success]="saldo > 0">
            <small class="text-muted fw-normal">COP </small>{{ saldo | number : "1.2-2" }}
          </h3>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- FILTROS -->
<div class="row">
  <div class="col-12 col-md-8">
    <div class="btn-group mb-3" role="group">
      <button
        type="button"
        class="btn btn-sm"
        [class.btn-primary]="filtro === 'TODOS'"
        [class.btn-outline-primary]="filtro !== 'TODOS'"
        (click)="cambiarFiltro('TODOS')"
      >
        Todos
      </button>
      <button
        type="button"
        class="btn btn-sm"
        [class.btn-primary]="filtro === 'PAGOS'"
        [class.btn-outline-primary]="filtro !== 'PAGOS'"
        (click)="cambiarFiltro('PAGOS')"
      >
        Pagos
      </button>
      <button
        type="button"
        class="btn btn-sm"
        [class.btn-primary]="filtro === 'SALDO'"
        [class.btn-outline-primary]="filtro !== 'SALDO'"
        (click)="cambiarFiltro('SALDO')"
      >
        Movimientos de saldo
      </button>
    </div>
  </div>
</div>

<!-- LISTADO -->
<div class="row">
  <div class="col-12 col-md-8">
    @if (cargando) {
    <div class="card">
      <div class="card-body text-center text-muted">
        <i class="fas fa-spinner fa-spin me-2"></i> Cargando tu historial...
      </div>
    </div>
    } @else if (error) {
    <div class="alert alert-warning">
      No fue posible cargar tu historial de pagos en este momento. Intenta de nuevo más tarde.
    </div>
    } @else if (movimientosFiltrados.length === 0) {
    <div class="card">
      <div class="card-body text-center text-muted">
        <i class="fas fa-receipt font-size-24 d-block mb-2"></i>
        Todavía no tienes movimientos registrados.
      </div>
    </div>
    } @else { @for (mov of movimientosFiltrados; track $index) {
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm order-2 order-sm-1">
            <div class="d-flex align-items-start mt-3 mt-sm-0">
              <div class="flex-grow-1">
                <h5 class="mb-1 text-primary">
                  <i class="{{ iconoMovimiento(mov) }} me-1"></i>
                  {{ tituloDe(mov) }}
                </h5>

                <span class="badge {{ resolverEstado(mov).clase }} font-size-12 mb-2">
                  {{ resolverEstado(mov).texto }}
                </span>

                <!-- Datos de la cita de la que salió el movimiento -->
                @if (citaDe(mov); as cita) {
                <div class="text-muted font-size-14 mb-2">
                  <div>
                    <i class="fas fa-calendar-alt me-1"></i>
                    <strong>
                      {{ convertToLocal(cita.fechaCita) | date : "dd/MM/yyyy" }}
                      a las {{ convertToLocal(cita.fechaCita) | date : "h:mm a" }}
                    </strong>
                  </div>
                  @if (especialistaDe(mov)) {
                  <div>
                    <i class="fas fa-user-md me-1"></i>
                    {{ especialistaDe(mov) }}
                  </div>
                  }
                  @if (sedeDe(mov)) {
                  <div>
                    <i class="fas fa-map-marker-alt me-1"></i>
                    {{ sedeDe(mov) }}
                    @if (consultorioDe(mov)) {
                    <span>· Consultorio {{ consultorioDe(mov) }}</span>
                    }
                  </div>
                  }
                </div>
                }

                <div
                  class="d-flex flex-wrap align-items-start gap-2 gap-lg-3 text-muted font-size-14"
                >
                  <div>
                    <i class="mdi mdi-circle-medium me-1 text-success align-middle"></i>
                    Registrado:
                    <strong>{{ convertToLocal(mov.fecha) | date : "dd/MM/yyyy" }}</strong>
                  </div>
                  @if (mov.banco && !esPagoConSaldo(mov)) {
                  <div>
                    <i class="mdi mdi-circle-medium me-1 text-success align-middle"></i>
                    Medio: <strong>{{ mov.banco }}</strong>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-auto order-1 order-sm-2">
            <div class="text-sm-end">
              <h3 class="mb-1 {{ claseValor(mov) }}">
                <small class="text-muted fw-normal">COP </small>{{ mov.valor | number : "1.2-2" }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    } }
  </div>
</div>
